import React from "react";
import CKEditor from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

const TOOLBAR = [
  "heading",
  "|",
  "bold",
  "italic",
  "underline",
  "|",
  "bulletedList",
  "numberedList",
  "|",
  "undo",
  "redo",
];

class RichTextEditor extends React.Component {
  toolbarRef = React.createRef();

  render() {
    const { value, onChange } = this.props;
    return (
      <div className="document-editor" style={{ border: "1px solid #c4c4c4", borderRadius: 4 }}>
        <div
          className="document-editor__toolbar"
          ref={this.toolbarRef}
          style={{ borderBottom: "1px solid #c4c4c4", background: "#fafafa" }}
        />
        <div style={{ padding: "8px 12px", minHeight: 120 }}>
          <CKEditor
            editor={DecoupledEditor}
            data={value || ""}
            config={{ toolbar: TOOLBAR }}
            onInit={(editor) => {
              if (this.toolbarRef.current) {
                this.toolbarRef.current.appendChild(editor.ui.view.toolbar.element);
              }
            }}
            onChange={(_event, editor) => {
              onChange(editor.getData());
            }}
          />
        </div>
      </div>
    );
  }
}

// Prepends a <style> block so bold/underline always render correctly
// regardless of Bootstrap or any other CSS resets in the host page.
export function injectRichStyles(html) {
  if (!html) return html;
  return `<style>strong,b{font-weight:700!important}u{text-decoration:underline!important}h1,h2,h3,h4{color:#111!important;-webkit-text-fill-color:#111!important;background-image:none!important;font-size:revert}</style>${html}`;
}

export default RichTextEditor;
